import { Radio } from '@iba-team/portal-react-components/dist';
import './Settings.scss';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';
import { EmployeeCoefficientT, SettingEmployeeT, SettingsCoefficientType } from '../../store/Settings';

export interface ChoiseRadioI {
  onChangeRadio: (item:Partial<EmployeeCoefficientT> ) => void,
  location?: string
  user:SettingEmployeeT,
  coefList: SettingsCoefficientType[]
}

export const SERVICE_LENGTH_GREATER_OR_EQUAL_N_YEARS = 26;
export const SERVICE_LENGTH_LESS_N_YEARS = 20;
export const NO_SERVICE_LENGTH = 1.66;

type PolandCoefficientType = 26 | 20 | 1.66;

const ChoiseExp = observer(({onChangeRadio,user, coefList}:ChoiseRadioI) => {
  const {t} = useTranslation();

  const findCoef = (coef:PolandCoefficientType )=> coefList.find(item=> item.id === user.vacationSettingId && item.defaultCoefficient === coef) !== undefined;
  return (
    <div className={'choice-radio'}>
      <Radio label={t('workExperienceMore')}
        checked={findCoef(SERVICE_LENGTH_GREATER_OR_EQUAL_N_YEARS)}
        onChange={(e)=>
          onChangeRadio({userId: user.userId, vacationSettingId: 8})}
        value={SERVICE_LENGTH_GREATER_OR_EQUAL_N_YEARS.toString()}/>
      <Radio label={t('workExperienceLess')}
        checked={findCoef(SERVICE_LENGTH_LESS_N_YEARS)}
        onChange={(e)=> onChangeRadio({userId: user.userId, vacationSettingId: 9})}
        value={SERVICE_LENGTH_LESS_N_YEARS.toString()}/>
      <Radio label={t('noWorkingExp')}
        checked={findCoef(NO_SERVICE_LENGTH)}
        onChange={(e)=>
          onChangeRadio({userId: user.userId, vacationSettingId: 10})}
        value={NO_SERVICE_LENGTH.toString()}/>
    </div>
  );
});

export default ChoiseExp;
